// SPDX-License-Identifier: AGPL-3.0-or-later

import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {matchVaultCode} from '@app/features/vault/commands/VaultCommands';
import {type TempDmCreateKind, TempDmCreateModal} from '@app/features/vault/components/TempDmCreateModal';
import {UnlockModal} from '@app/features/vault/components/UnlockModal';
import type {VaultCode} from '@app/features/vault/constants';

export function openUnlockModal(code: VaultCode): void {
	ModalCommands.push(ModalCommands.modal(() => <UnlockModal code={code} data-flx="vault.unlock-modal" />));
}

export function openTempDmCreateModal(kind: TempDmCreateKind = 'temp'): void {
	ModalCommands.push(ModalCommands.modal(() => <TempDmCreateModal kind={kind} />));
}

/**
 * Intercepts secret codes typed into personal notes. Returns true when the
 * content was a code: the caller must clear the composer without sending.
 */
export function handlePotentialVaultCode(channelId: string, content: string): boolean {
	const code = matchVaultCode(channelId, content);
	if (code === null) return false;
	openUnlockModal(code);
	return true;
}
